import {
  RESET_AD_NETWORKS_TYPES,
  SET_AD_NETWORKS_TYPES,
  RESET_CALCULATE_AWARDS,
  SET_CALCULATE_AWARDS,
} from 'modules/PartnersProgram/types'

const initialState = {}

export default function partnersProgramReducer(state = initialState, action) {
  switch (action.type) {
    case SET_CALCULATE_AWARDS:
    case SET_AD_NETWORKS_TYPES: {
      return {
        ...state,
        ...action.payload,
      }
    }
    case RESET_CALCULATE_AWARDS:
    case RESET_AD_NETWORKS_TYPES: {
      return { ...initialState }
    }
    default:
      return state
  }
}
